module.exports = __webpack_public_path__ + "img/coding-not-css.c1301e03.svg";